import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"adock-card mt-2"},[_c(VCardTitle,{attrs:{"primary-title":""}},[_c('h2',[_vm._v("Messages")])]),_c('ThreadList',{attrs:{"threads-url":_vm.threadsUrl,"get-router-thread-url":_vm.getRouterThreadUrl,"show-id":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }